// 接口请求路径
export const appBaseApi = window.globalConfig.baseUrl

// 基础路径
export const appBaseUrl = process.env.BASE_URL
